(() => {
  function removeGroup(owner) {
    document.querySelectorAll('[data-ff-trust-owner]').forEach(group => {
      if (group.dataset.ffTrustOwner === owner) group.remove();
    });
  }

  function mount(scope) {
    scope.querySelectorAll('template[data-ff-trust-template]').forEach(template => {
      const group = template.content.firstElementChild;
      const anchor = document.querySelector('#ss-trust-badges-6') || document.querySelector('.slider-mobile-gutter');
      if (!group || !anchor) return;
      removeGroup(template.dataset.ffTrustTemplate);
      group.dataset.ffTrustOwner = template.dataset.ffTrustTemplate;
      anchor.insertAdjacentElement('afterend', group);
    });
  }

  if (customElements.get('ff-trust-icon')) {
    mount(document);
    return;
  }

  function paladinRenderer(canvas, image, reducedMotion, onFailure) {
      let elapsed = 0;
      const boundary = [[0, 24.5], [28, 24.5], [42, 33.5], [50, 29.3], [62, 31], [72, 35.6], [88, 46]];
      function innerWingEdge(y) {
        for (let i = 1; i < boundary.length; i++) {
          if (y <= boundary[i][0]) {
            const [y0, x0] = boundary[i - 1];
            const [y1, x1] = boundary[i];
            return x0 + (x1 - x0) * (y - y0) / (y1 - y0);
          }
        }
        return 46;
      }
      function makeLayers() {
        const sample = document.createElement('canvas');
        sample.width = sample.height = 100;
        const context = sample.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0);
        const pixels = context.getImageData(0, 0, 100, 100).data;
        const crest = new Uint8Array(10000);
        const queue = [16 * 100 + 50];
        crest[queue[0]] = 1;
        for (let head = 0; head < queue.length; head++) {
          const index = queue[head];
          const x = index % 100, y = Math.floor(index / 100);
          for (const [dx, dy] of [[-1, 0], [1, 0], [0, -1], [0, 1]]) {
            const nx = x + dx, ny = y + dy, next = ny * 100 + nx;
            if (nx < 0 || nx >= 100 || ny < 0 || ny >= 100 || crest[next] || pixels[next * 4 + 3] < 96) continue;
            crest[next] = 1;
            queue.push(next);
          }
        }
        const resolution = 4;
        const size = 100 * resolution;
        sample.width = sample.height = size;
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = 'high';
        context.drawImage(image, 0, 0, size, size);
        const detail = context.getImageData(0, 0, size, size).data;
        const layers = ['left', 'right', 'shield'].map(name => {
          const canvas = document.createElement('canvas');
          canvas.width = canvas.height = size;
          const context = canvas.getContext('2d');
          return { name, canvas, context, pixels: context.createImageData(size, size) };
        });
        for (let row = 0; row < size; row++) {
          for (let column = 0; column < size; column++) {
            const x = (column + .5) / resolution;
            const y = (row + .5) / resolution;
            const index = (row * size + column) * 4;
            if (!detail[index + 3]) continue;
            let fixed = false;
            for (let dy = -1; dy <= 1; dy++) {
              for (let dx = -1; dx <= 1; dx++) {
                const nx = Math.floor(x) + dx, ny = Math.floor(y) + dy;
                if (nx >= 0 && nx < 100 && ny >= 0 && ny < 100 && crest[ny * 100 + nx]) fixed = true;
              }
            }
            const edge = innerWingEdge(y);
            const distance = x < 49.5 ? edge - x : x - (99 - edge);
            const wing = !fixed && y < 88 && distance > 0;
            const layer = layers[wing ? (x < 49.5 ? 0 : 1) : 2];
            const tint = Math.max(0, Math.min(1, (y - 14) / 70));
            const color = [239 + (179 - 239) * tint, 148 + (245 - 148) * tint, 255 + (238 - 255) * tint];
            const transition = Math.max(0, Math.min(1, (distance - 1) / 9));
            const saturation = transition * transition * (3 - 2 * transition);
            const blended = color.map(channel => 255 + (channel - 255) * saturation);
            for (let channel = 0; channel < 3; channel++) {
              layer.pixels.data[index + channel] = wing ? detail[index + channel] * blended[channel] / 255 : detail[index + channel];
            }
            layer.pixels.data[index + 3] = detail[index + 3];
            // Extend the moving root underneath the stationary shield to hide the join.
            if (!wing && !fixed && y < 88 && distance > -1.5) {
              const underneath = layers[x < 49.5 ? 0 : 1].pixels.data;
              for (let channel = 0; channel < 3; channel++) underneath[index + channel] = detail[index + channel] * blended[channel] / 255;
              underneath[index + 3] = detail[index + 3];
            }
          }
        }
        for (const layer of layers) layer.context.putImageData(layer.pixels, 0, 0);
        return layers;
      }
      function createRenderer(canvas, layers) {
        const context = canvas.getContext('2d');
        if (!context) throw new Error('The animation renderer is unavailable.');
        const renderer = {
          draw(seconds) {
            elapsed = seconds;
            context.setTransform(canvas.width / 124, 0, 0, canvas.height / 124, 0, 0);
            context.clearRect(0, 0, 124, 124);
            context.save();
            context.translate(12, 4);
            context.imageSmoothingEnabled = true;
            context.imageSmoothingQuality = 'high';
            const opening = reducedMotion.matches ? 0 : .5 - .5 * Math.cos(seconds * Math.PI * 2 / 4.8);
            for (let index = 0; index < 2; index++) {
              const side = index === 0 ? -1 : 1;
              const pivotX = index === 0 ? 31 : 68;
              context.save();
              context.translate(pivotX, 55);
              context.rotate(side * .195 * opening);
              context.translate(-pivotX, -55);
              context.drawImage(layers[index].canvas, 0, 0, 100, 100);
              context.restore();
            }
            context.drawImage(layers[2].canvas, 0, 0, 100, 100);
            const stars = context.createLinearGradient(12, 0, 88, 0);
            stars.addColorStop(0, '#ef94ff'); stars.addColorStop(1, '#b3f5ee');
            context.fillStyle = stars;
            for (const [x, y, radius] of [[9, 86, 6.6], [28.5, 100, 6.6], [50, 106, 7.2], [71.5, 100, 6.6], [91, 86, 6.6]]) {
              if (!reducedMotion.matches) {
                const initialTint = Math.max(0, Math.min(1, (x - 12) / 76));
                const colorPhase = seconds * Math.PI * 2 / 12 + Math.acos(1 - 2 * initialTint);
                const tint = .5 - .5 * Math.cos(colorPhase);
                context.fillStyle = `rgb(${239 - 60 * tint}, ${148 + 97 * tint}, ${255 - 17 * tint})`;
              }
              context.beginPath();
              for (let point = 0; point < 10; point++) {
                const angle = -Math.PI / 2 + point * Math.PI / 5;
                const length = point % 2 ? radius * .44 : radius;
                const px = x + Math.cos(angle) * length, py = y + Math.sin(angle) * length;
                if (point === 0) context.moveTo(px, py); else context.lineTo(px, py);
              }
              context.closePath(); context.fill();
            }

            context.restore();
          },
          resize() {
            const bounds = canvas.getBoundingClientRect();
            const ratio = Math.min(devicePixelRatio || 1, 3);
            canvas.width = Math.max(1, Math.round(bounds.width * ratio));
            canvas.height = Math.max(1, Math.round(bounds.height * ratio));
            renderer.draw(elapsed);
          }
        };
        renderer.resize();
        return renderer;
      }
      return createRenderer(canvas, makeLayers());
  }


      function flatRenderer(canvas, reducedMotion, paint) {
        const context = canvas.getContext('2d');
        if (!context) throw new Error('The preview could not initialize.');
        let elapsed = 0;
        const renderer = {
          draw(seconds) {
            elapsed = seconds;
            context.setTransform(canvas.width / 100, 0, 0, canvas.height / 100, 0, 0);
            context.clearRect(0, 0, 100, 100);
            context.lineCap = 'round';
            context.lineJoin = 'round';
            paint(context, reducedMotion.matches ? 0 : seconds);
          },
          resize() {
            const bounds = canvas.getBoundingClientRect();
            const ratio = Math.min(devicePixelRatio || 1, 3);
            canvas.width = Math.max(1, Math.round(bounds.width * ratio));
            canvas.height = Math.max(1, Math.round(bounds.height * ratio));
            renderer.draw(elapsed);
          }
        };
        renderer.resize();
        return renderer;
      }
      function paintCoin(context) {
        context.strokeStyle = '#ffffff'; context.lineWidth = 3.8;
        context.beginPath(); context.arc(50, 50, 22, 0, Math.PI * 2); context.stroke();
        context.lineWidth = 3.3; context.beginPath(); context.moveTo(57.5, 41);
        context.bezierCurveTo(54, 35.5, 41.5, 36.5, 41.5, 43.5);
        context.bezierCurveTo(41.5, 50.5, 58.5, 48, 58.5, 56);
        context.bezierCurveTo(58.5, 63.5, 45, 65, 40.5, 58.5);
        context.moveTo(50, 32.5); context.lineTo(50, 67.5); context.stroke();
      }
      function paintArrow(context, start, end) {
        const gradient = context.createLinearGradient(12, 12, 88, 88);
        gradient.addColorStop(0, '#ef94ff'); gradient.addColorStop(1, '#b3f5ee');
        context.strokeStyle = gradient; context.fillStyle = gradient; context.lineWidth = 4.4;
        context.beginPath(); context.arc(50, 50, 37, start, end, true); context.stroke();
        const x = 50 + 37 * Math.cos(end), y = 50 + 37 * Math.sin(end);
        const tx = Math.sin(end), ty = -Math.cos(end);
        context.beginPath();
        context.moveTo(x + tx * 3, y + ty * 3);
        context.lineTo(x - tx * 8 - ty * 5.4, y - ty * 8 + tx * 5.4);
        context.lineTo(x - tx * 8 + ty * 5.4, y - ty * 8 - tx * 5.4);
        context.closePath(); context.fill();
      }
      function momentumCoinFrame(seconds) {
        const tau = Math.PI * 2;
        const smoother = value => value * value * value * (value * (value * 6 - 15) + 10);
        const clamp = value => Math.max(0, Math.min(1, value));
        const time = (seconds % 5.6) / 5.6;
        const phase = clamp((time - .18) / (.82 - .18));
        const travel = smoother(phase);
        // Grow with the turn so the trailing end keeps moving forward.
        const minimumAt = .36, ramp = .18;
        const minimumTravel = smoother(minimumAt);
        const growthTravel = clamp((travel - minimumTravel) / (1 - minimumTravel));
        const y = clamp(growthTravel / ramp);
        const rampArea = ramp * (y ** 6 - 3 * y ** 5 + 2.5 * y ** 4);
        const growth = (growthTravel < ramp ? rampArea : growthTravel - ramp / 2) / (1 - ramp / 2);
        const retract = phase < minimumAt
          ? smoother(clamp(phase / minimumAt))
          : 1 - growth;
        const drift = tau * .12 * (seconds / 5.6);
        return {
          angle: .15 * Math.PI - tau * travel - drift,
          sweep: (297 - (297 - 90) * retract) * Math.PI / 180
        };
      }
      function paintMomentumArrow(context, frame) {
        const smoother = value => value * value * value * (value * (value * 6 - 15) + 10);
        const head = frame.angle, tail = head + frame.sweep;
        const gradient = context.createLinearGradient(15, 12, 85, 88);
        gradient.addColorStop(0, '#ef94ff'); gradient.addColorStop(1, '#b3f5ee');
        context.strokeStyle = gradient;
        const segments = Math.ceil(frame.sweep * 15);
        for (let index = 0; index < segments; index++) {
          const fraction = index / segments;
          const start = tail - frame.sweep * fraction;
          const end = tail - frame.sweep * (index + 1) / segments;
          context.lineWidth = 1.65 + 2.75 * smoother(fraction);
          context.beginPath(); context.arc(50, 50, 37, start, end - .0015, true); context.stroke();
        }
        const x = 50 + 37 * Math.cos(head), y = 50 + 37 * Math.sin(head);
        const tx = Math.sin(head), ty = -Math.cos(head);
        context.fillStyle = gradient;
        context.beginPath();
        context.moveTo(x + tx * 3.4, y + ty * 3.4);
        context.lineTo(x - tx * 6.8 - ty * 5, y - ty * 6.8 + tx * 5);
        context.lineTo(x - tx * 4.7, y - ty * 4.7);
        context.lineTo(x - tx * 6.8 + ty * 5, y - ty * 6.8 - tx * 5);
        context.closePath(); context.fill();
      }
      function momentumCoinRenderer(canvas, image, reducedMotion) {
        return flatRenderer(canvas, reducedMotion, (context, seconds) => {
          paintCoin(context);
          paintMomentumArrow(context, momentumCoinFrame(seconds));
        });
      }
      function coinRenderer(canvas, image, reducedMotion) {
        return flatRenderer(canvas, reducedMotion, (context, seconds) => {
          paintCoin(context);
          const lapTime = seconds % 5.8;
          const phase = Math.min(lapTime / 2.8, 1);
          const sweep = phase - 3 / (4 * Math.PI) * Math.sin(2 * Math.PI * phase)
            + 3 / (20 * Math.PI) * Math.sin(4 * Math.PI * phase)
            - 1 / (60 * Math.PI) * Math.sin(6 * Math.PI * phase);
          const progress = lapTime / 30 + (1 - 5.8 / 30) * sweep;
          const angle = -Math.PI * 2 * progress;
          paintArrow(context, -.2 * Math.PI + angle, -1.85 * Math.PI + angle);
        });
      }
  function infinityRenderer(canvas, image, reducedMotion) {
      const infinityCurves = [
    [39.4, 35.4525, 33.04, 30.1625, 23.5, 30.1625],
    [13.96, 30.1625, 6.54, 38.0975, 6.54, 50],
    [6.54, 61.9025, 13.96, 69.8375, 23.5, 69.8375],
    [33.04, 69.8375, 39.4, 64.5475, 50, 50],
    [60.6, 35.4525, 66.96, 30.1625, 76.5, 30.1625],
    [86.04, 30.1625, 93.46, 38.0975, 93.46, 50],
    [93.46, 61.9025, 86.04, 69.8375, 76.5, 69.8375],
    [66.96, 69.8375, 60.6, 64.5475, 50, 50]
  ];
      const traceMaps = new WeakMap();
      const traceSegments = [];
      let previousPoint = [50, 50], traceLength = 0;
      infinityCurves.forEach((curve, curveIndex) => {
        const start = previousPoint;
        for (let step = 1; step <= 80; step++) {
          const t = step / 80, u = 1 - t;
          const x = u * u * u * start[0] + 3 * u * u * t * curve[0] + 3 * u * t * t * curve[2] + t * t * t * curve[4];
          const y = u * u * u * start[1] + 3 * u * u * t * curve[1] + 3 * u * t * t * curve[3] + t * t * t * curve[5];
          const dx = x - previousPoint[0], dy = y - previousPoint[1], length = Math.hypot(dx, dy);
          traceSegments.push({ x: previousPoint[0], y: previousPoint[1], dx, dy, length, distance: traceLength, pass: curveIndex < 2 || curveIndex > 5 ? 0 : 1 });
          traceLength += length;
          previousPoint = [x, y];
        }
      });

      function traceStroke(context, width, height, start, curves, closed) {
        context.setTransform(width / 100, 0, 0, height / 100, 0, 0);
        context.clearRect(0, 0, 100, 100);
        context.beginPath(); context.moveTo(...start);
        for (const curve of curves) context.bezierCurveTo(...curve);
        if (closed) context.closePath();
        context.lineWidth = 6.4; context.lineCap = 'round'; context.lineJoin = 'round';
        context.strokeStyle = '#ffffff'; context.stroke();
        return context.getImageData(0, 0, width, height);
      }

      function createTraceMap(context, canvas) {
        const width = canvas.width, height = canvas.height, count = width * height;
        const pixels = traceStroke(context, width, height, [50, 50], infinityCurves, true);
        const coverage = [
          traceStroke(context, width, height, [93.46, 50], [...infinityCurves.slice(6), ...infinityCurves.slice(0, 2)], false).data,
          traceStroke(context, width, height, [6.54, 50], infinityCurves.slice(2, 6), false).data
        ];
        const passes = coverage.map(() => ({ distance: new Float32Array(count).fill(Infinity), position: new Float32Array(count), coverage: new Float32Array(count) }));
        for (const segment of traceSegments) {
          const pass = passes[segment.pass];
          const endX = segment.x + segment.dx, endY = segment.y + segment.dy;
          const left = Math.max(0, Math.floor((Math.min(segment.x, endX) - 4.5) * width / 100));
          const right = Math.min(width - 1, Math.ceil((Math.max(segment.x, endX) + 4.5) * width / 100));
          const top = Math.max(0, Math.floor((Math.min(segment.y, endY) - 4.5) * height / 100));
          const bottom = Math.min(height - 1, Math.ceil((Math.max(segment.y, endY) + 4.5) * height / 100));
          for (let row = top; row <= bottom; row++) {
            const y = (row + .5) * 100 / height - segment.y;
            for (let column = left; column <= right; column++) {
              const index = row * width + column;
              if (!coverage[segment.pass][index * 4 + 3]) continue;
              const x = (column + .5) * 100 / width - segment.x;
              const t = Math.max(0, Math.min(1, (x * segment.dx + y * segment.dy) / (segment.length * segment.length)));
              const dx = x - segment.dx * t, dy = y - segment.dy * t;
              const distance = dx * dx + dy * dy;
              if (distance >= pass.distance[index]) continue;
              pass.distance[index] = distance;
              pass.position[index] = (segment.distance + segment.length * t) / traceLength;
            }
          }
        }
        const active = [];
        for (let index = 0; index < count; index++) {
          const alpha = pixels.data[index * 4 + 3];
          if (!alpha) continue;
          active.push(index);
          passes.forEach((pass, part) => {
            pass.coverage[index] = Number.isFinite(pass.distance[index]) ? Math.min(1, coverage[part][index * 4 + 3] / alpha) : 0;
          });
        }
        const map = { width, height, pixels, active, passes };
        traceMaps.set(canvas, map);
        return map;
      }

      function draw(context, canvas, seconds) {
        let map = traceMaps.get(canvas);
        if (!map || map.width !== canvas.width || map.height !== canvas.height) map = createTraceMap(context, canvas);
        const center = ((reducedMotion.matches ? 0 : seconds / 6.4) + .12) % 1;
        const purple = [239, 148, 255], blue = [179, 245, 238];
        const accent = purple;
        const base = blue;
        for (const index of map.active) {
          let intensity = 0;
          for (const pass of map.passes) {
            if (!pass.coverage[index]) continue;
            let distance = Math.abs(pass.position[index] - center);
            distance = Math.min(distance, 1 - distance);
            const fadeDistance = Math.max(0, distance - .045);
            const band = Math.exp(-.5 * (fadeDistance / .16) ** 2);
            intensity = Math.max(intensity, band * pass.coverage[index]);
          }
          const offset = index * 4;
          for (let channel = 0; channel < 3; channel++) map.pixels.data[offset + channel] = base[channel] + (accent[channel] - base[channel]) * intensity;
        }
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.putImageData(map.pixels, 0, 0);
      }
      const context = canvas.getContext('2d');
      if (!context) throw new Error('The animation renderer is unavailable.');
      let elapsed = 0;
      const renderer = {
        draw(seconds) { elapsed = seconds; draw(context, canvas, seconds); },
        resize() {
          const bounds = canvas.getBoundingClientRect();
          const ratio = Math.min(devicePixelRatio || 1, 3);
          canvas.width = Math.max(1, Math.round(bounds.width * ratio));
          canvas.height = Math.max(1, Math.round(bounds.height * ratio));
          renderer.draw(elapsed);
        }
      };
      renderer.resize();
      return renderer;
  }


  class FFTrustIcon extends HTMLElement {
    connectedCallback() {
      const generation = this.generation = (this.generation || 0) + 1;
      this.elapsed = 0;
      this.last = null;
      this.frame = null;
      this.visible = false;
      this.failed = false;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const synchronize = () => this.synchronize();
      this.motion.addEventListener('change', synchronize, { signal });
      document.addEventListener('visibilitychange', synchronize, { signal });
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.initialize(generation);
        this.synchronize();
      });
      this.visibilityObserver.observe(this);
    }

    async initialize(generation) {
      if (this.loading || this.renderer || this.failed) return;
      this.loading = true;
      try {
        let image;
        if (this.dataset.kind === 'paladin') {
          image = new Image();
          image.crossOrigin = 'anonymous';
          image.src = this.dataset.source;
          await image.decode();
        }
        if (!this.isConnected || generation !== this.generation) return;
        const canvas = this.querySelector('canvas');
        const factories = { paladin: paladinRenderer, coin: this.dataset.motion === 'momentum' ? momentumCoinRenderer : coinRenderer, infinity: infinityRenderer };
        this.renderer = factories[this.dataset.kind](canvas, image, this.motion, () => {
          this.failed = true;
          this.dataset.ready = 'false';
          this.synchronize();
        });
        this.resizeObserver = new ResizeObserver(() => {
          if (!this.renderer || this.failed) return;
          this.renderer.resize();
          this.renderer.draw(this.elapsed);
        });
        this.resizeObserver.observe(canvas);
        this.dataset.ready = 'true';
        this.synchronize();
      } catch {
        if (generation !== this.generation) return;
        this.failed = true;
        this.dataset.ready = 'false';
        this.synchronize();
      } finally {
        if (generation === this.generation) this.loading = false;
      }
    }

    synchronize() {
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.last = null;
      if (!this.renderer || this.failed || !this.isConnected) return;
      this.renderer.draw(this.elapsed);
      if (!this.visible || document.hidden || this.motion.matches) return;
      const tick = now => {
        if (this.last !== null) this.elapsed += Math.min((now - this.last) / 1000, .05);
        this.last = now;
        this.renderer.draw(this.elapsed);
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    disconnectedCallback() {
      this.generation++;
      this.controller?.abort();
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.renderer?.dispose?.();
      this.renderer = null;
      this.loading = false;
      this.dataset.ready = 'false';
      const canvas = this.querySelector('canvas');
      if (canvas) canvas.replaceWith(canvas.cloneNode(false));
    }
  }

  customElements.define('ff-trust-icon', FFTrustIcon);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('template[data-ff-trust-template]').forEach(template => removeGroup(template.dataset.ffTrustTemplate));
  });
})();
